import RenderPdf from "../../containers/ManegeProcedure/RenderPdf";
import GenerateRoadmap from "../../containers/ManegeProcedure/GenerateRoadmap";
import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import RenderProforma from "../../containers/ManegeProcedure/RenderProforma";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import { validateArray } from "../../utils/validate";
import { Tooltip } from "react-tippy";
import ListDocument from "../../components/common/ListDocument";
import ListDocumentVerify from "../../components/common/ListDocumentVerify";
import { FormQuotes } from "../../containers/ManegeProcedure/FormQuotes";
import { GenerateRoadmapPDF } from "../../containers/ManegeProcedure/GenerateRoadmapPDF";
import { FormDocument } from "../../containers/ManegeProcedure/FormDocument";

const TableLisDocument = ({ listButton, procedure }) => {
  const { openDialog, dialogClose } = useDialog();
  const { openModal, onClose } = useModal();

  function listDocumentPdf(procedure) {
    openDialog(<RenderPdf procedure={procedure} />);
  }
  function generateSettlementProforma(procedure) {
    openDialog(<RenderLiquidaciónProforma procedure={procedure} />);
  }

  function generateProforma(procedure) {
    openModal(<FormQuotes procedure={procedure} />);

    // openDialog(<RenderProforma procedure={procedure} />);
  }

  function handleDeliveryOfDocuments(procedure) {
    openModal(<FormDocument procedure={procedure} />);
  }

  function generateRoadmap(procedure) {
    openDialog(<GenerateRoadmapPDF procedure={procedure} />);
  }
  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} />);
  }
  function handleDocumentVerify(procedure) {
    openModal(<ListDocumentVerify procedure={procedure} />);
  }
  function handleEntregaDeDocumentos(procedure) {
    openModal(
      <FormDocument
        listFields={["entregaDeDocumentos"]}
        name="Entrega de documentos"
        procedure={procedure}
      />
    );
  }

  let listGeneralButtons = [
    {
      label: "Generar informe de la recepción de documentos",
      icon: "fas fa-tasks",
      Name: "recepcionDeDocumentos",
      action: listDocumentPdf,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Generar liquidación - proforma",
      icon: "fas fa-coins",
      Name: "trz-002-proforma",
      action: generateProforma,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Solicitud de documentos",
      icon: "fas fa-handshake",
      Name: "trz-003-solicitudDeDocumentos",
      action: handleDeliveryOfDocuments,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Generar hoja de ruta",
      icon: "fas fa-route",
      Name: "trz-001-hojaDeRuta",
      action: generateRoadmap,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Ver documentos",
      icon: "fa-solid fa-folder",
      Name: "verDocumentos",
      action: handleDocument,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Verificar documentos",
      icon: "fa-solid fa-list-check",
      Name: "verificarDocumentos",
      action: handleDocumentVerify,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Entrega de docuementos",
      icon: "fa-solid fa-list-check",
      Name: "trz-005-entregaDeDocumentos",
      action: handleEntregaDeDocumentos,
      color: "text-[#1d4ed8]",
    },
  ];

  return (
    <>
      {validateArray(listButton)
        ? listButton.map((btn, index) => {
            const button = listGeneralButtons.find(
              (element) => element.Name === btn.Name
            );
            if (button === undefined) {
              return null;
            }
            return (
              <div
                key={index}
                className={`${button.color} text-xl cursor-pointer`}
                onClick={() => button.action(procedure)}
              >
                <Tooltip
                  title={button.label}
                  position="right"
                  trigger="mouseenter"
                >
                  <i className={button.icon + " p-1"}></i>
                </Tooltip>
              </div>
            );
          })
        : null}
    </>
  );
};

export default TableLisDocument;
